export default {
    addEventDefaultTitle: "Termin durch Klick oder Drag'n'Drop hinzufügen",
}
